export const servicesList = ["VIRTUAL", "RHAPSODY", "CHAT_ONLY", "ADVICE_CHAT", "ADVICE_VIDEO", "RX_VIDEO", "IMMEDIATE_CHAT", "IMMEDIATE_CALL"];
export const servicesChat = ["IMMEDIATE_CHAT", "CHAT_ONLY", "ADVICE_CHAT"];
export const servicesVirtual = ["ADVICE_VIDEO", "IMMEDIATE_CALL", "VIRTUAL", "RX_VIDEO"];
export const appointmentsAdvice = ["ADVICE_CHAT", "ADVICE_VIDEO"];

export const servicesObj = [
	{id: "ADVICE_CHAT",name: "ADVICE_CHAT"},
	{id: "ADVICE_VIDEO",name: "ADVICE_VIDEO"},
	{id: "RX_VIDEO",name: "RX_VIDEO"},
]

export const serviceType = [
	{id: 1, label: "Pop-up", checked: false},
	{id: 2, label: "In-home", checked: false},
	{id: 3, label: "Chat", checked: false}
];

export const adviceServices = [
	{type: "ADVICE_VIDEO", label: "Video - $35", checked: false},
	{type: "ADVICE_CHAT", label: "Chat - $35", checked: false},
];

export const adviceServiceAtlanta = [
	{type: "ADVICE_VIDEO", label: "Video", checked: false},
];

export const RX_Services = [
	{type: "RX_VIDEO", label: "Video - $55", checked: false},
];
export const reasons = [
	{type: "PRESCRIPTION", label: "Advice + Medications", checked: false},
	{type: "ADVICE&TRIAGE", label: "Advice", checked: false}
];

export const immediateServices = [
	{type: "IMMEDIATE_CHAT", label: "Chat", checked: false},
];

export const dates = [
	{type: "IMMEDIATELY", label: "Next Available", checked: false},
	{type: "SCHEDULE_LATER", label: "Schedule Later", checked: false},
];

export const setType = (type) => {
	switch (type) {
	case "RX_VIDEO":
		return "RX Video";
	case "VIRTUAL":
	case "ADVICE_VIDEO":
		return "Video";
	case "CHAT_ONLY":
	case "ADVICE_CHAT":
		return "Chat";
	case "IMMEDIATE_CHAT":
		return "Immediate Chat";
	case "IMMEDIATE_CALL":
		return "Immediate Call";
	case "RHAPSODY":
		return "In-person - easyvet";
	default:
		return "Chat";
	}
};

export const setTypeForVet = (type) => {
	switch (type) {
		case "RX_VIDEO":
			return "RX Video";
		case "VIRTUAL":
		case "ADVICE_VIDEO":
			return "Advice Video (no RX)";
		case "CHAT_ONLY":
		case "ADVICE_CHAT":
			return "Advice Chat (no RX)";
		case "IMMEDIATE_CHAT":
			return "Immediate Chat";
		case "IMMEDIATE_CALL":
			return "Immediate Call";
		case "RHAPSODY":
			return "In-person - easyvet";
		default:
			return "Chat";
	}
};

export const setAppointmentPrice = (type) => {
	switch (type) {
	case "RX_VIDEO":
	case "DEFAULT":
		return "55";
	case "ADVICE_VIDEO":
	case "ADVICE_CHAT":
	case "IMMEDIATE_CHAT":
	case "IMMEDIATE_CALL":
	case "ADVICE":
		return "35";
	case "VIRTUAL":
	case "CHAT_ONLY":
		return "50";
	default:
		return "35";
	}
};

export const setAppointmentFee = (type) => {
	switch (type) {
		case "ADVICE":
			return "30";
		default:
			return "50";
	}
}

export const getAppointmentType = (type) => {
	if (type === "RX_VIDEO") {
		return "Advice + Medication Appointment ";
	}
	return "Advice Appointment";
};
